import React from 'react';
import { LayoutListItemContent } from 'components/LayoutListItem/LayoutListItemContent';
import { isGroupLayoutDocument } from 'utils/entityType';
import styles from './styles.module.scss';

const LayoutListItemDragPreview = ({ document, thumbnailUrl }): React.ReactElement => {
  const isGroupLayout = isGroupLayoutDocument(document);

  return (
    <div className={styles.LayoutListItemDragPreview}>
      <LayoutListItemContent isGroupLayout={isGroupLayout} document={document} thumbnailUrl={thumbnailUrl} isPreview={true}/>
    </div>
  );
};

export default LayoutListItemDragPreview;
